import React from "react";
import Card from "./Card";
import projectsList from "./projectList";

const Projects = () => {
  return (
    <section className="w-11/12 lg:w-9/12">
      <h1 className="text-center my-12 text-4xl text-white">Projects</h1>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 items-center">
        {projectsList.map((project) => (
          <Card
            key={project.title}
            src={project.src}
            title={project.title}
            description={project.description}
            liveLink={project.liveLink}
            sourceLink={project.sourceLink}
          />
        ))}
      </div>
      <div className="flex justify-center items-center text-lg underline py-3">
        <a
          className="text-white hover:text-yellow-300"
          href="https://github.com/aniketnegii?tab=repositories"
          target="_blank"
          rel="noreferrer"
        >
          To view more visit my github{"  -->"}
        </a>
      </div>
    </section>
  );
};

export default Projects;
